import React, { ReactElement } from 'react'
import Template from '../../HelperClass/Template/Row'
import Points from '../../HelperClass/Points'
import { BasicStandingRowProps, Points as PointProps } from '../../HelperClass/StandingsRowTypes'

export type Props = BasicStandingRowProps & PointProps

const TennisRow = ({
    onRowPress,
    rank,
    tendency,
    onMorePress,
    leagueQualifierColor,
    competitorLogoUrl,
    competitorName,
    competitorLogoAlt,
    hasDivider,
    imageType,
    points,
    additionalInfoLabel,
    testID,
    isCompetitorBold,
}: Props): ReactElement => {
    return (
        <Template
            rank={rank}
            testID={testID}
            tendency={tendency}
            onRowPress={onRowPress}
            competitorLogoUrl={competitorLogoUrl}
            leagueQualifierColor={leagueQualifierColor}
            onMorePress={onMorePress}
            competitorName={competitorName}
            additionalInfoLabel={additionalInfoLabel}
            competitorLogoAlt={competitorLogoAlt}
            hasDivider={hasDivider}
            imageType={imageType}
            isCompetitorBold={isCompetitorBold}
        >
            <Points points={points} width={64} />
        </Template>
    )
}

export default TennisRow
